import { Text, TextProps } from '@solvhealth/jigsaw-v1';
import Booking from '@solvhealth/types/interfaces/Booking';
import Provider from '@solvhealth/types/interfaces/Provider/index';
import React from 'react';
import { PREMIUM_VISIT_NAME } from '~/components/Membership/constants';
import { isPremiumBooking, isTelemedBooking } from '~/core/util/booking';
import { formatLocationNameFromBooking } from '../../../../../../../../../core/util/location';
import { getProviderName } from '../../../../../../../../ProviderGroup/Provider/util';

type Props = {
  booking: Booking;
  provider?: Provider;
  textProps?: TextProps;
};

export function ClinicOrProviderName({ booking, provider, textProps }: Props) {
  if (isPremiumBooking(booking) && isTelemedBooking(booking)) {
    return (
      <Text {...textProps} variant="h4">
        {PREMIUM_VISIT_NAME} &ndash; Video visit
      </Text>
    );
  }

  return (
    <Text {...textProps} variant="h4">
      {(provider && getProviderName(provider)) || formatLocationNameFromBooking(booking)}
    </Text>
  );
}
